// signOutSlipTrack.js -- the one way the app signs a user out of SlipTrack on this phone.
// Single job: end the sportsbook session (#1415 D6, iOS), then the local Supabase session, so no sign-out path can
// skip the sportsbook clear (Codex P1 on #1476: the onboarding block screen called supabase.auth.signOut directly).
// Reads/writes: the in-app browser's cookie store (through session-reset) and the local Supabase session.
// Does not: report errors. It returns the Supabase result and lets a throw through, so each caller keeps its own
// handling and severity. signout-single-path.guard.test.js fails on any other auth.signOut caller in src/.
import { supabase } from './supabase';
import { canSignOutOfSportsbooks, signOutOfSportsbooks } from './slipsync/session-reset';

export async function signOutSlipTrack() {
  // signOutOfSportsbooks never throws. A failed clear is already a warning, and the owner-key reset it does first
  // forces the next sync (by anyone, the same user included) to clear.
  if (canSignOutOfSportsbooks()) await signOutOfSportsbooks();
  return supabase && supabase.auth ? supabase.auth.signOut({ scope: 'local' }) : { error: null };
}
